var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Loader",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-loader","viewBox":"0 0 1000 1000"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M867.5 10v165.9C777.7 74.1 646.4 10 500 10 229.4 10 10 229.4 10 500s219.4 490 490 490 490-219.4 490-490H867.5c0 98.2-38.3 190.4-107.6 259.9S598.2 867.5 500 867.5c-98.2 0-190.4-38.3-259.9-107.6-69.3-69.5-107.6-161.7-107.6-259.9 0-98.2 38.3-190.4 107.6-259.9 69.5-69.3 161.7-107.6 259.9-107.6 98.2 0 190.4 38.3 259.9 107.6 4.8 4.8 9.6 9.8 14 14.9H622.5v122.5H990V10H867.5z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/loader.svg